export const config = {
  apiUrl: 'https://api-dev.solutiicolaborative.ro',
  googleId: '883195298556-e39h3luh3heom8kp7dfu4colhr1rrtg2.apps.googleusercontent.com',
  facebookId: '2755850208019370',
};
